import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";

const LABEL_COLOR = colors.text.tertiary;
const VALUE_COLOR = colors.neutral.white;

interface ProfileFieldRowProps {
  label: string;
  value: string;
}

const ProfileFieldRow = ({ label, value }: ProfileFieldRowProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
    <Box
      component="span"
      sx={{
        fontFamily: "Outfit, sans-serif",
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "27px",
        color: LABEL_COLOR,
      }}
    >
      {label}
    </Box>
    <Box
      component="span"
      sx={{
        fontFamily: "Outfit, sans-serif",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "22px",
        color: VALUE_COLOR,
      }}
    >
      {value}
    </Box>
  </Box>
);

export default ProfileFieldRow;
